module.exports = __webpack_public_path__ + "media/images/top/place-banner-f982ea723721c574fb5b4cf7468e3cb3.jpg";